import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GalleryComponent } from '../../../shared/components/gallery/gallery.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { getInformation } from '../../../shared/constants/ci-information.constant';
import { GalleryProjectComponent } from '../../../shared/components/gallery-project/gallery-project.component';
import { GalleryInformationComponent } from '../../../shared/components/gallery-information/gallery-information.component';
import { GalleryDeviceComponent } from '../../../shared/components/gallery-device/gallery-device.component';
import { ProjectFeaturesComponent } from '../../../shared/components/project-features/project-features.component';
import { GalleryBannerComponent } from '../../../shared/components/gallery-banner/gallery-banner.component';
import { NavbarComponent } from '../../../shared/components/navbar/navbar.component';
import { MapSensorComponent } from '../../../shared/components/map-sensor/map-sensor.component';
import { FooterComponent } from "../../../shared/components/footer/footer.component";

@Component({
  selector: 'app-project',
  standalone: true,
  templateUrl: './project.component.html',
  imports: [GalleryComponent, GalleryBannerComponent, GalleryProjectComponent, RouterModule, NgFor, NgIf, GalleryInformationComponent, GalleryDeviceComponent, ProjectFeaturesComponent, NavbarComponent, MapSensorComponent, FooterComponent],
})
export class ProjectPageComponent implements OnInit {

  public slug!: any;
  public data: any;

  constructor(private _route: ActivatedRoute,
    private _cdr: ChangeDetectorRef) {
    this.data = null;
  }

  async ngOnInit() {
    await this._getSlugParam();
    this.scrollToTop();
  }

  public scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private async _getSlugParam() {
    this._route.paramMap.subscribe(params => {
      this.data = null;
      this.slug = params.get('id');

      if (this.slug) {
        this._getInformation();
      }
      this._cdr.detectChanges();
    });
  }

  private _getInformation() {
    this.data = getInformation(this.slug);
  }
}
